import { EndUserCertKeyType, EndUserSignAlgo, EndUserHashAlgo, ExtKeyUsagesSeal } from '@/sign/models/sign-constants';

export function determineSignAlgorithm(keyType: number): EndUserSignAlgo {
  let signAlgo = EndUserSignAlgo.DSTU4145WithGOST34311;
  if (keyType === EndUserCertKeyType.DSTU4145) {
    signAlgo = EndUserSignAlgo.DSTU4145WithGOST34311;
  } else if (keyType === EndUserCertKeyType.RSA) {
    signAlgo = EndUserSignAlgo.RSAWithSHA;
  } else if (keyType === EndUserCertKeyType.ECDSA) {
    signAlgo = EndUserSignAlgo.ECDSAWithSHA;
  }
  return signAlgo;
}

export function determineHashAlgorithm(keyType: number): EndUserHashAlgo {
  let hashAlgo = EndUserHashAlgo.Unknown;
  if (keyType === EndUserCertKeyType.RSA || keyType === EndUserCertKeyType.ECDSA) {
    hashAlgo = EndUserHashAlgo.SHA256;
  } else if (keyType === EndUserCertKeyType.DSTU4145) {
    hashAlgo = EndUserHashAlgo.GOST34311;
  }
  return hashAlgo;
}

export function determineKeyTypeByCertificates(certificates): string {
  let keyTypeName = '';
  if (certificates && certificates.length) {
    let keyType = certificates[0].infoEx.publicKeyType;
    if ([EndUserCertKeyType.DSTU4145, EndUserCertKeyType.RSA, EndUserCertKeyType.ECDSA].includes(keyType)) {
      keyTypeName = EndUserCertKeyType[keyType];
    }
  }
  return keyTypeName;
}

export function isSealCertificates(certificates: Array<any>): boolean {
  let isSeal = false;
  let sealExtKeyUsages = [ExtKeyUsagesSeal.Default, ExtKeyUsagesSeal.Bluetooth];
  if (!!certificates && certificates.length > 0) {
    isSeal = certificates
      .some(c => !!c.infoEx && !!c.infoEx.extKeyUsages &&
                 c.infoEx.extKeyUsages.split(',').some(k => !!k && sealExtKeyUsages.includes(k.trim().toLowerCase()))
      );
  }
  return isSeal;
}
